"use strict";

class DeveloperProfileController {

    constructor($parse, SSHttpService, SSUtilService, SSAlertService, SSAwsService, SSUserService) {
        const self = this;

        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.has_access = false;

        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.getDeveloperProfile();
    }

    getDeveloperProfile() {
        const self = this;

        self.developer = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developer = response.data.developer;

            self.maskPhoneNumber(self, 'ctrl.');
        });
    }

    saveDeveloperProfile() {
        const self = this;

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#developerProfile')))
            return;

        let url = 'sec/developer/profile';
        let params = {
            name: self.developer.name,
            email: self.developer.email,
            phone1: self.developer.phone1,
            phone2: self.developer.phone2,
            address: self.developer.address,

            biz_reg_no: self.developer.profile.biz_reg_no,
            website: self.developer.profile.website,
            about: self.developer.profile.about,
            code: self.developer.profile.code,
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Developer profile updated successfully.');

            self.developer = response.data.developer;

            self.maskPhoneNumber(self, 'ctrl.');
        });
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        let parent = jQuery;
        if (formId) {
            parent = jQuery('#' + formId);
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {

                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    uploadFile(file, type) {
        const self = this;

        let policyUrl = 'api/1.0/sec/developer/profile/s3-policy-document'; // TODO: Need to fix api/<version> prefix

        loading(true);
        self.SSAwsService.upload(file, policyUrl, function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.postAsset({
                "file_uri": response.config.data.key,
                "name": response.config.data.file.name,
                "type": type
            });
        });
    }

    postAsset(params) {
        const self = this;

        let url = 'sec/developer/profile/add-asset';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            self.developer = response.data.developer;
        });
    }

    removeAsset(type) {
        const self = this;

        let url = 'sec/developer/profile/remove-asset';

        loading(true);
        self.SSHttpService.postAPIRequest(url, {'type': type}).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File removed successfully.');

            self.developer = response.data.developer;
        });
    }

}

DeveloperProfileController.$inject = ['$parse', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSAwsService', 'SSUserService'];
app.controller('DeveloperProfileController', DeveloperProfileController);